import { __awaiter, __generator } from "tslib";
export function getDocumentThumbnailUrl(item) {
    return __awaiter(this, void 0, void 0, function () {
        var getThumbnailService, thumbnailUrl, service;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    getThumbnailService = function () {
                        return import(
                        /*webpackChunkName: "vroom-service" */ '@office-start/vroom-service');
                    };
                    thumbnailUrl = '';
                    if (!(item.driveId && item.docId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getThumbnailService()];
                case 1:
                    service = _a.sent();
                    return [4 /*yield*/, service
                            .getThumbnailString(!!item.isMsftDogfood, item.driveId, item.docId)
                            .catch(function () { return ''; })];
                case 2:
                    thumbnailUrl = _a.sent(); // catch error
                    _a.label = 3;
                case 3: return [2 /*return*/, thumbnailUrl];
            }
        });
    });
}
//# sourceMappingURL=getDocumentThumbnailUrl.js.map